export const ZonesAndSubZones = {
  GET_ZONES: "GET_ZONES",
  GET_ZONES_SUCCESS: "GET_ZONES_SUCCESS",
  GET_ZONES_FAILURE: "GET_ZONES_FAILURE",
  CLEAR_ZONES: "CLEAR_ZONES",

  SELECT_ZONE: "SELECT_ZONE",
  UN_SELECT_ZONE: "UN_SELECT_ZONE",

  // create
  CREATE_ZONE: "CREATE_ZONE",
  CREATE_ZONE_SUCCESS: "CREATE_ZONE_SUCCESS",
  CREATE_ZONE_FAILURE: "CREATE_ZONE_FAILURE",

  // update
  UPDATE_ZONE: "UPDATE_ZONE",
  UPDATE_ZONE_SUCCESS: "UPDATE_ZONE_SUCCESS",
  UPDATE_ZONE_FAILURE: "UPDATE_ZONE_FAILURE",

  // delete
  DELETE_ZONE: "DELETE_ZONE",
  DELETE_ZONE_SUCCESS: "DELETE_ZONE_SUCCESS",
  DELETE_ZONE_FAILURE: "DELETE_ZONE_FAILURE",

  // form
  OPEN_CREATE_AND_UPDATE_ZONE_MODAL: "OPEN_CREATE_AND_UPDATE_ZONE_MODAL",
  CLOSE_CREATE_AND_UPDATE_ZONE_MODAL: "CLOSE_CREATE_AND_UPDATE_ZONE_MODAL",

  CLEAR_SELECTED_REGION_AND_ZONES_MAP: "CLEAR_SELECTED_REGION_AND_ZONES_MAP",

  // Sub Zones
  GET_SUB_ZONES: "GET_SUB_ZONES",
  GET_SUB_ZONES_SUCCESS: "GET_SUB_ZONES__SUCCESS",
  GET_SUB_ZONES_FAILURE: "GET_SUB_ZONES_FAILURE",
  CLEAR_SUB_ZONES: "CLEAR_SUB_ZONES",

  // create
  CREATE_SUB_ZONES: "CREATE_SUB_ZONES",
  CREATE_SUB_ZONES_SUCCESS: "CREATE_SUB_ZONES_SUCCESS",
  CREATE_SUB_ZONES_FAILURE: "CREATE_SUB_ZONES_FAILURE",

  // update
  UPDATE_SUB_ZONES: "UPDATE_SUB_ZONES",
  UPDATE_SUB_ZONES_SUCCESS: "UPDATE_SUB_ZONES_SUCCESS",
  UPDATE_SUB_ZONES_FAILURE: "UPDATE_SUB_ZONES_FAILURE",

  // delete
  DELETE_SUB_ZONES: "DELETE_SUB_ZONES",
  DELETE_SUB_ZONES_SUCCESS: "DELETE_SUB_ZONES_SUCCESS",
  DELETE_SUB_ZONES_FAILURE: "DELETE_SUB_ZONES_FAILURE",

  // form
  OPEN_CREATE_AND_UPDATE_SUB_ZONES_MODAL:
    "OPEN_CREATE_AND_UPDATE_SUB_ZONES_MODAL",
  CLOSE_CREATE_AND_UPDATE_SUB_ZONES_MODAL:
    "CLOSE_CREATE_AND_UPDATE_SUB_ZONES_MODAL",
};
